/**
 * actions
 */
const SET_EMS_USER = 'SET_EMS_USER';

/**
 * reducers
 */
const initialState = {
  user: null,
};

export const reducers = (state = initialState, action) => {
  switch (action.type) {
    case SET_EMS_USER:
      return {
        ...state,
        ...action.payload
      };
    default:
      return state;
  }
};

/**
 * action creaters
 */
export function setEmsUser(user) {
  return {
    type: SET_EMS_USER,
    payload: { user },
  };
}
